// import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { branch, compose, renderNothing } from 'recompose'
import { userSelector } from '../../store/selectors/baseSelectors'
import {
  sidebarFolderSelector,
  sidebarShowingSelector
} from '../../store/selectors/sidebarSelectors'
import { toggleActivity } from '../../store/actions/activity'
import { activityShowingSelector } from '../../store/selectors/activitySelectors';

export default compose(
  connect(state => {
    const folder = !!sidebarFolderSelector(state)
    return {
      showing: sidebarShowingSelector(state),
      folder
    }
  }),
  branch(({ showing }) => !showing, renderNothing),
  connect(
    state => {
      const user = userSelector(state)
      return {
        anon: user.isEmpty || user.isAnonymous,
        activityShowing: activityShowingSelector(state),
      }
    },
    { toggleActivity }
  )
)
